import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38a9ea20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=38a9ea20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a9ea20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a9ea20')) {
      api.createRecord('38a9ea20', component.options)
    } else {
      api.reload('38a9ea20', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38a9ea20&scoped=true", function () {
      api.rerender('38a9ea20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fileUpload/index.vue"
export default component.exports